export const REQUEST_BASE_URL = '/request/privilegedAccess';
export const JITA_REQUEST_BASE_URL = '/request/jitAccess';

// UX Design Breakpoints and Naming Structure (guide only do not edit):
// Mobile:
// 360px: 140 MobileXSmall (This is below our minimum, but it’s a common Android size, adding it here just in case)
// 375px: 130 MobileSmall
// 480px: 120 MobileLarge
// 600px: 110 MobileXLarge

// Tablet:
// 768px: 100 TabletXSmall
// 834px: 90 TabletSmall
// 900px: 80 TabletMedium
// 960px: 70 TabletLarge
// 1024px: 60 TabletXLarge

// Desktop:
// 1280px: 50 DesktopSmall
// 1366px: 40 DesktopMedium
// 1440px: 30 DesktopLarge
// 1600px: 20 DesktopXLarge
// 1920px: 10 DesktopXXLarge

// Screen descriptions
export const SCREEN_SIZE_MOBILE_XLARGE = 'MobileXLarge';
export const SCREEN_SIZE_TABLET_SMALL = 'TabletSmall';

// Add to these SCREEN_WIDTH_QUERIES as needed for certs responsivness
export const SCREEN_WIDTH_QUERIES = [
  { query: '(max-width: 599px)', value: 110, label: SCREEN_SIZE_MOBILE_XLARGE },
  { query: '(max-width: 833px)', value: 90, label: SCREEN_SIZE_TABLET_SMALL },
];

// Feel free to add/move your own msgs related constants here.
export const msgs = {
  pam: {
    common: {
      successExclamation: {
        id: 'pam.common.successExclamation',
        defaultMessage: 'Success!',
      },
    },
    landingPage: {
      clearSelection: {
        id: 'pam.landingPage.clearSelection',
        defaultMessage: 'Clear Selection',
      },
      clear: {
        id: 'pam.landingPage.clear',
        defaultMessage: 'Clear',
      },
      selected: {
        id: 'pam.landingPage.selected',
        defaultMessage: 'Selected',
      },
      view: {
        id: 'pam.landingPage.view',
        defaultMessage: 'View',
      },
      filter: {
        id: 'pam.landingPage.filter',
        defaultMessage: 'Filter',
      },
      errors: {
        assetsNotLoaded: {
          id: 'pam.landingPage.errors.assetsNotLoaded',
          defaultMessage: 'Assets Not Loaded',
        },
        assetsNotLoadedDesc: {
          id: 'pam.landingPage.errors.assetsNotLoadedDesc',
          defaultMessage:
            "Your list of privileged assets didn't load properly. Try again or contact your administrator.",
        },
      },
      hideSessions: {
        id: 'pam.landingPage.hideSessions',
        defaultMessage: 'Hide Sessions',
      },
      userAccessSearchInputPlaceholder: {
        id: 'pam.landingPage.userAccessSearchInputPlaceholder',
        defaultMessage:
          'Search by target system name, application name or role name',
      },
      userAccessSearchInputPlaceholderJfa: {
        id: 'pam.landingPage.userAccessSearchInputPlaceholderJfa',
        defaultMessage: 'Search by role, application, etc.',
      },
      description: {
        id: 'pam.landingPage.description',
        defaultMessage:
          'Connect to your privileged assets so you can launch live sessions and check credentials out when you need them.',
      },
      descriptionJfa: {
        id: 'pam.landingPage.descriptionJfa',
        defaultMessage:
          'Connect to roles and accounts of applications when you need them through JIT access.',
      },
      noMatchingSearchRecords: {
        id: 'pam.landingPage.noMatchingSearchRecords',
        defaultMessage: "Your search doesn't match any records",
      },
      noAssetsAvailable: {
        id: 'pam.landingPage.noAssetsAvailable',
        defaultMessage: 'There are no available assets',
      },
      sessionsHeader: {
        id: 'pam.landingPage.sessionsHeader',
        defaultMessage: 'Sessions',
      },
      availableAssetsHeader: {
        id: 'pam.landingPage.availableAssetsHeader',
        defaultMessage: 'Available Assets',
      },
      availableRolesHeader: {
        id: 'pam.landingPage.availableRolesHeader',
        defaultMessage: 'Available Roles',
      },
      maxRolesSelected: {
        id: 'pam.landingPage.maxRolesSelected',
        defaultMessage:
          'The max number of roles has been reached. Uncheck one to add another.',
      },
      checkOutRoles: {
        id: 'pam.landingPage.checkOutRoles',
        defaultMessage: 'Check Out Roles',
      },
      bulkRoleSelectPopoverTitle: {
        id: 'pam.landingPage.bulkRoleSelectPopoverTitle',
        defaultMessage: 'Bulk Selection Filtering Applied',
      },
      bulkRoleSelectPopoverSubTitle: {
        id: 'pam.landingPage.bulkRoleSelectPopoverSubTitle',
        defaultMessage:
          'Only roles can be bulk selected currently. Filters and search are available, but some options will be disabled.',
      },
      bulkRoleSelectPopoverCheckBox: {
        id: 'pam.landingPage.bulkRoleSelectPopoverCheckBox',
        defaultMessage: 'Don’t show me this again',
      },
      bulkRoleSelectPopoverSubmitButton: {
        id: 'pam.landingPage.bulkRoleSelectPopoverSubmitButton',
        defaultMessage: 'Got It',
      },
      bulkRoleSelectRoleFilterTooltip: {
        id: 'pam.landingPage.bulkRoleSelectRoleFilterTooltip',
        defaultMessage:
          'Filtering by role type is unavailable while taking a bulk action on roles.',
      },
      account: {
        id: 'pam.landingPage.account',
        defaultMessage: 'Account',
      },
      platform: {
        id: 'pam.landingPage.platform',
        defaultMessage: 'Platform',
      },
      assetType: {
        id: 'pam.landingPage.assetType',
        defaultMessage: 'Asset Type',
      },
      roleType: {
        id: 'pam.landingPage.roleType',
        defaultMessage: 'Role Type',
      },
    },
    requestSubmitAlertBanner: {
      pending: {
        id: 'pam.requestSubmitAlertBanner.pending',
        defaultMessage: 'Your request for {accountName} is Pending Approval.',
      },
      approved: {
        id: 'pam.requestSubmitAlertBanner.approved',
        defaultMessage:
          'Your request for {accountName} has been approved and will be available soon. Refresh your list in a few minutes.',
      },
    },
    requestRoleSubmitAlertBanner: {
      submitted: {
        id: 'pam.requestRoleSubmitAlertBanner.submitted',
        defaultMessage: 'Your request for {roleName} has been submitted.',
      },
    },
    upload: {
      uploadFailed: {
        id: 'pam.upload.uploadFailed',
        defaultMessage: 'Upload Failed',
      },
      uploadFailedDesc: {
        id: 'pam.upload.uploadFailedDesc',
        defaultMessage: 'Your files for {accountName} could not be uploaded.',
      },
    },
  },
};
